import { createFileRoute } from "@tanstack/react-router";
import { VelgSelskapPage } from "@/features/auth/VelgSelskapPage";

export const Route = createFileRoute("/_app/selskap")({
  component: VelgSelskapPage,
  head: () => ({
    meta: [
      {
        title: "Velg Selskap | Kundeportal for fjernvarme",
      },
    ],
  }),
});
